import React from 'react';
import Home from './Pages/Home/Home';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";


// icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab, faCodepen, faFacebook, faFacebookF, faLinkedin, faTwitch } from '@fortawesome/free-brands-svg-icons'
import { faCheckSquare, faCoffee,  faEnvelope,  faExternalLinkAlt, faEye, faFolder, faFolderOpen,  faMapMarkerAlt, faPhone} from '@fortawesome/free-solid-svg-icons'
import ContactPage from './Pages/ContactPage/ContactPage';
import About from './Pages/About/About';
import Page from './Pages/Page/Page';
import Work from './Components/Work/Work';
import Blog from './Components/Blog/Blog';

library.add(fab, faCheckSquare, faCoffee, faFacebook, faExternalLinkAlt, faFolderOpen, faEye, faFolder, faLinkedin, faCodepen, faFacebook, faTwitch, faPhone, faEnvelope, faMapMarkerAlt, faFacebookF)

function App() {
  return (
    <Router>
      <Switch>

        <Route exact path="/">
          <Home></Home>
        </Route>

        <Route path="/contact">
          <ContactPage></ContactPage>
        </Route>

        <Route path="/work">
        <Page title="work">
            <Work isHome={false}></Work>
        </Page>
        </Route>

        <Route path="/about">
          <About></About>
        </Route>

        <Route path="/blog">
          <Page title="blog">
            <Blog></Blog>
          </Page>
        </Route>
        
      </Switch>
     
    </Router>
  );
}

export default App;
